import { WidgetType } from 'modules/dashboard/types/widgets/widget.enums';
import { WidgetLayoutEntry } from './clientLayoutConfig';
import { downloadExcelText, HelpHeadingText, HelpSubText } from './helpContent';
import { ICONS_ENUM } from '@sanlam-glacier/app-common/components';

export const enum IntermediaryWidgetLabels {
  bookSummary = 'Book summary',
  topFunds = 'Top 5 funds',
  topAssetManagers = 'Top 5 asset managers',
  hotlinks = 'Hotlinks',
  todoList = 'To-do List',
  events = 'Events',
  caseTracking = 'Case tracking'
}
export const intermediaryLayoutMap: Record<IntermediaryWidgetLabels, WidgetLayoutEntry> = {
  [IntermediaryWidgetLabels.bookSummary]: {
    layouts: {
      lg: { x: 0, y: 0, w: 4, h: 4 },
      md: { x: 0, y: 0, w: 4, h: 4 },
      sm: { x: 0, y: 0, w: 5, h: 4 }
    },
    widgetProps: {
      widgetConfig: {
        type: WidgetType.bookSummary,
        heading: IntermediaryWidgetLabels.bookSummary,
        helpHeadingText: HelpHeadingText.BookSummary,
        helpSubText: HelpSubText.BookSummary,
        isHidable: true,
        isScrollable: true
      }
    },
    chartProps: null,
    tableProps: null
  },
  [IntermediaryWidgetLabels.topFunds]: {
    layouts: {
      lg: { x: 4, y: 0, w: 3, h: 4 },
      md: { x: 0, y: 4, w: 5, h: 4 },
      sm: { x: 0, y: 4, w: 4, h: 4 }
    },
    widgetProps: {
      widgetConfig: {
        type: WidgetType.topFunds,
        heading: IntermediaryWidgetLabels.topFunds,
        helpHeadingText: HelpHeadingText.Top5Funds,
        helpSubText: HelpSubText.Top5Funds,
        isScrollable: true
      }
    },
    chartProps: null,
    tableProps: null
  },
  [IntermediaryWidgetLabels.topAssetManagers]: {
    layouts: {
      lg: { x: 7, y: 0, w: 3, h: 4 },
      md: { x: 4, y: 0, w: 3, h: 4 },
      sm: { x: 4, y: 4, w: 3, h: 4 }
    },
    widgetProps: {
      widgetConfig: {
        type: WidgetType.topAssetManagers,
        heading: IntermediaryWidgetLabels.topAssetManagers,
        helpHeadingText: HelpHeadingText.Top5AssetManagers,
        helpSubText: HelpSubText.Top5AssetManagers,
        isScrollable: true
      }
    },
    chartProps: null,
    tableProps: null
  },
  [IntermediaryWidgetLabels.hotlinks]: {
    layouts: {
      lg: { x: 10, y: 0, w: 2, h: 4 },
      md: { x: 7, y: 0, w: 2, h: 4 },
      sm: { x: 5, y: 0, w: 2, h: 4 }
    },
    widgetProps: {
      widgetConfig: {
        type: WidgetType.hotlinks,
        heading: IntermediaryWidgetLabels.hotlinks,
        removeElements: true,
        isScrollable: true
      }
    },
    chartProps: null,
    tableProps: null
  },
  [IntermediaryWidgetLabels.todoList]: {
    layouts: {
      lg: { x: 0, y: 4, w: 9, h: 5 },
      md: { x: 0, y: 8, w: 9, h: 5 },
      sm: { x: 0, y: 12, w: 7, h: 5 }
    },
    widgetProps: {
      widgetConfig: {
        type: WidgetType.todoList,
        heading: IntermediaryWidgetLabels.todoList,
        helpHeadingText: HelpHeadingText.TodoList,
        helpSubText: HelpSubText.TodoList,
        hasProperties: true,
        customActionIcon: ICONS_ENUM.FILE_DOWNLOAD,
        customActionText: downloadExcelText,
        isScrollable: false
      }
    },
    chartProps: null,
    tableProps: null
  },
  [IntermediaryWidgetLabels.events]: {
    layouts: {
      lg: { x: 9, y: 4, w: 3, h: 10 },
      md: { x: 5, y: 4, w: 4, h: 4 },
      sm: { x: 4, y: 8, w: 3, h: 4 }
    },
    widgetProps: {
      widgetConfig: {
        type: WidgetType.events,
        heading: IntermediaryWidgetLabels.events,
        helpHeadingText: HelpHeadingText.Events,
        helpSubText: HelpSubText.Events,
        isScrollable: false
      }
    },
    chartProps: null,
    tableProps: null
  },
  [IntermediaryWidgetLabels.caseTracking]: {
    layouts: {
      lg: { x: 0, y: 9, w: 9, h: 5 },
      md: { x: 0, y: 13, w: 9, h: 5 },
      sm: { x: 0, y: 8, w: 4, h: 4 }
    },
    widgetProps: {
      widgetConfig: {
        type: WidgetType.caseTracking,
        heading: IntermediaryWidgetLabels.caseTracking,
        helpHeadingText: HelpHeadingText.CaseTracking,
        helpSubText: HelpSubText.CaseTracking,
        isScrollable: true
      }
    },
    chartProps: null,
    tableProps: null
  }
};
